import { Directive, Renderer2, ElementRef, HostBinding, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { PopoverRef } from './popover-ref';

/**
 * Internal directive that shows the popover arrow.
 */
@Directive({
  selector: '[popoverArrow]',
  standalone: true
})
export class PopoverArrowDirective {
  @HostBinding('style.width.px')
  @HostBinding('style.height.px')
  arrowSize: number;

  @HostBinding('style.top.px')
  offsetTop!: number|undefined;

  @HostBinding('style.right.px')
  offsetRight!: number|undefined;

  @HostBinding('style.bottom.px')
  offsetBottom!: number|undefined;

  @HostBinding('style.left.px')
  offsetLeft!: number|undefined;

  private subscription = new Subscription();

  constructor(private popoverRef: PopoverRef,
    private cd: ChangeDetectorRef) {
    this.arrowSize = popoverRef.config.arrowSize ?? 0;

    this.subscription = popoverRef.positionChanges().subscribe(p => {
      const popoverWidth = this.popoverRef.overlayRef.overlayElement.offsetWidth;
      //       this.offsetTop = 50;//offsetY >= 0 ? offsetY * -1 : null;
      let panelClass = p.connectionPair.panelClass;
      this.offsetBottom = (panelClass!.includes('bottom') &&  panelClass!.includes('center')) ? -1 * this.arrowSize / 4 :undefined;
      this.offsetTop = (panelClass!.includes('top') &&  panelClass!.includes('center')) ? -1 * this.arrowSize/4  : undefined;      
      this.offsetRight = (panelClass!.includes('right') && panelClass!.includes('center')) ? -1 * this.arrowSize / 2 : undefined;//offsetX >= 0 ? offsetX : null;
      this.offsetLeft =   (panelClass!.includes('bottom') && panelClass!.includes('center')) ? popoverWidth / 2 - this.arrowSize / 2 :
          ((panelClass!.includes('top') && panelClass!.includes('center'))) ? popoverWidth / 2 - this.arrowSize / 2 : undefined;

      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}